import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { route as notificationsPage } from "@faire/web-api--source/routes/user/notifications";
import { useLocation } from "react-router-dom";
export var useIsOnNotificationsPage = function() {
    var pathname = useLocation().pathname;
    return pathMatchesRoute(pathname, notificationsPage);
};
